import request from 'superagent';
import { updateCourse, receiveCourse } from './courses';
import { startLoad, finishLoad } from './loader';
import { addQuery, addError } from './utils';

function receiveTasks(tasks) {
  return {
    type: 'RECEIVE_TASKS',
    tasks,
  };
}

function receiveNextLesson(nextLessonId) {
  return {
    type: 'RECEIVE_NEXT_LESSON',
    nextLessonId,
  };
}

export function getTasks() {
  return dispatch => {
    dispatch(startLoad('getTasks', 'Получение заданий'));
    request.post('/task/list').end((err, res) => {
      dispatch(finishLoad('getTasks'));
      if (err) {
        dispatch(receiveTasks([]));
      } else {
        dispatch(receiveTasks(res.body));
      }
    });
  };
}

export function getTasksByLesson(lessonId, newIndex) {
  return dispatch => {
    dispatch(startLoad('getTasks', 'Получение заданий для урока'));
    request.post(`/task/list/all/${lessonId}`).end((err, res) => {
      dispatch(finishLoad('getTasks'));
      if (err) {
        dispatch(receiveTasks([]));
        dispatch(selectTask(-1, 0));
        dispatch(
          addError(
            (res && res.body) ||
              'Не удалось загрузить задания урока. Попробуйте обновить страницу.'
          )
        );
      } else {
        dispatch(receiveTasks(res.body.tasks));
        dispatch(receiveCourse(res.body.course));
        dispatch(receiveNextLesson(res.body.nextLesson));
        //addQuery({ course: courseId });
        if (newIndex >= 0 && newIndex < res.body.tasks.length) {
          dispatch(selectTask(newIndex, 0));
        }
      }
    });
  };
}

export function getEditableTasks(courseId) {
  return dispatch => {
    dispatch(startLoad('getTasks', 'Получение заданий для курса'));
    request.post(`/task/list/editable/${courseId}`).end((err, res) => {
      dispatch(finishLoad('getTasks'));
      if (err) {
        dispatch(receiveTasks([]));
      } else {
        dispatch(receiveTasks(res.body.tasks));
        addQuery({ course: courseId });
      }
    });
  };
}

export function selectTask(id, frame) {
  //addQuery({ task: id});
  return {
    type: 'SELECT_TASK',
    id,
    frame,
  };
}

export function selectFrame(frame) {
  return {
    type: 'SELECT_FRAME',
    frame,
  };
}

export function updateTask(task, silent) {
  return dispatch => {
    if (!silent) {
      dispatch(startLoad('updateTask', 'Сохранение задания'));
    }
    request
      .post('/task/update')
      .send({ task })
      .end((err, res) => {
        if (!silent) {
          dispatch(finishLoad('updateTask'));
        }
        if (err) {
          dispatch(
            addError(
              (res && res.body) ||
                'Не удалось сохранить задание. Проверьте права доступа.'
            )
          );
        } else {
          dispatch(receiveTasks(res.body));
        }
      });
  };
}

export function createTask(taskId, course, section, theme, lesson) {
  return dispatch => {
    dispatch(startLoad('createTask', 'Создание задания'));
    request
      .post('/task/create')
      .send({})
      .end((err, res) => {
        dispatch(finishLoad('createTask'));
        if (err) {
          dispatch(receiveTasks([]));
        } else {
          const { newTask } = res.body;
          course.sections[section].themes[theme].lessons[lesson].taskIds.splice(
            taskId,
            0,
            newTask._id
          );
          dispatch(updateCourse(course));
        }
      });
  };
}

export function deleteTask(_id) {
  return dispatch => {
    dispatch(startLoad('deleteTask', 'Удаление задания'));
    request.delete(`/task/${_id}`).end((err, res) => {
      dispatch(finishLoad('deleteTask'));
      if (err) {
        dispatch(receiveTasks([]));
      } else {
        //dispatch(receiveTasks(res.body));
        //dispatch(selectTask(res.body.length - 1));
      }
    });
  };
}
